import gql from 'graphql-tag'
import client from '@stores/apollo'
import { IEdge, TicketSearchResult } from '@api/types'
import { TicketSearchResultFragment } from '@api/fragments'

export interface Payload {
  data: {
    viewer: {
      company: {
        tickets: {
          edges: IEdge<TicketSearchResult>[]
        }
      }
    }
  }
}

export default function search(searchQuery: string): Promise<TicketSearchResult[]> {
  const variables = { query: searchQuery }
  return client.gql.query({ query, variables }).then(
    ({
      data: {
        viewer: {
          company: {
            tickets: { edges },
          },
        },
      },
    }: Payload) => edges.map(({ node }) => node)
  )
}

const query = gql`
  query TicketSearch($query: String) {
    viewer {
      company {
        tickets(first: 7, query: $query) {
          edges {
            node {
              ...TicketSearchResultFragment
            }
          }
        }
      }
    }
  }
  ${TicketSearchResultFragment}
`
